import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "sensor-normalizations-view" }

import { ref, onMounted, computed } from 'vue'
import { useSensorNormalizationStore } from './store'
import { SensorNormalization } from './models/sensorNormalization'


export default /*@__PURE__*/_defineComponent({
  __name: 'SensorNormalizationsView',
  setup(__props) {

const sensorNormalizationStore = useSensorNormalizationStore()
const loading = ref(false)
const selectedSensorId = ref<string | null>(null)
const selectedSensorSettingId = ref<string | null>(null)
const statusFilter = ref<string | null>(null)

const headers = [
  { title: 'ID', key: 'id' },
  { title: 'Sensor ID', key: 'sensorId' },
  { title: 'Config ID', key: 'sensorSettingId' },
  { title: 'Inicio', key: 'initDate' },
  { title: 'Fin', key: 'endDate' },
  { title: 'Mult', key: 'multDelta' },
  { title: 'Suma', key: 'sumDelta' },
  { title: 'Div', key: 'divDelta' },
  { title: 'Actualizado', key: 'refreshed' },
  { title: 'Estado', key: 'status' },
  { title: 'Acciones', key: 'actions', sortable: false },
]

// Opciones para los filtros (en un caso real, estos vendrían de otros stores)
const sensorOptions = ref([
  { title: 'Sensor A', value: 'sensorA' },
  { title: 'Sensor B', value: 'sensorB' },
  { title: 'Sensor C', value: 'sensorC' },
])

const sensorSettingOptions = ref([
  { title: 'Config 1', value: 'config1' },
  { title: 'Config 2', value: 'config2' },
  { title: 'Config 3', value: 'config3' },
])

const statusOptions = ref([
  { title: 'Activo', value: 'active' },
  { title: 'Expirado', value: 'expired' },
  { title: 'Futuro', value: 'future' },
  { title: 'Actualizado', value: 'refreshed' },
  { title: 'Pendiente', value: 'pending' },
])

const sensorNormalizationsList = computed(() => {
  let list = sensorNormalizationStore.sensorNormalizations
  
  if (selectedSensorId.value) {
    list = list.filter(item => item.sensorId === selectedSensorId.value)
  }
  
  if (selectedSensorSettingId.value) {
    list = list.filter(item => item.sensorSettingId === selectedSensorSettingId.value)
  }
  
  if (statusFilter.value) {
    const now = new Date()
    list = list.filter(item => {
      const initDate = new Date(item.initDate)
      const endDate = new Date(item.endDate)
      
      switch (statusFilter.value) {
        case 'active':
          return now >= initDate && now <= endDate
        case 'expired':
          return now > endDate
        case 'future':
          return now < initDate
        case 'refreshed':
          return item.refreshed
        case 'pending':
          return !item.refreshed
        default:
          return true
      }
    })
  }
  
  return list
})

const formatDate = (date: Date | string) => {
  return new Date(date).toLocaleDateString('es-ES')
}

const getStatusColor = (item: SensorNormalization) => {
  const now = new Date()
  const initDate = new Date(item.initDate)
  const endDate = new Date(item.endDate)
  
  if (now < initDate) return 'info'     // Futuro
  if (now > endDate) return 'error'     // Expirado
  if (now >= initDate && now <= endDate) return 'success' // Activo
  return 'default'
}

const getStatusText = (item: SensorNormalization) => {
  const now = new Date()
  const initDate = new Date(item.initDate)
  const endDate = new Date(item.endDate)
  
  if (now < initDate) return 'Futuro'
  if (now > endDate) return 'Expirado'
  if (now >= initDate && now <= endDate) return 'Activo'
  return 'Indefinido'
}

const refreshData = async () => {
  loading.value = true
  try {
    await sensorNormalizationStore.getSensorNormalizations()
  } finally {
    loading.value = false
  }
}

const filterBySensor = async (sensorId: string | null) => {
  if (sensorId) {
    loading.value = true
    try {
      await sensorNormalizationStore.getSensorNormalizationsBySensorId(sensorId)
    } finally {
      loading.value = false
    }
  } else {
    refreshData()
  }
}

const filterBySensorSetting = async (sensorSettingId: string | null) => {
  if (sensorSettingId) {
    loading.value = true
    try {
      await sensorNormalizationStore.getSensorNormalizationsBySensorSettingId(sensorSettingId)
    } finally {
      loading.value = false
    }
  } else {
    refreshData()
  }
}

const filterByStatus = () => {
  // El filtrado por estado se maneja en el computed
}

const addItem = () => {
  // Implementar lógica para agregar normalización
  console.log('Add new sensor normalization')
}

const editItem = (item: SensorNormalization) => {
  // Implementar lógica de edición
  console.log('Edit item:', item)
}

const deleteItem = (item: SensorNormalization) => {
  // Implementar lógica de eliminación
  console.log('Delete item:', item)
}

const refreshNormalization = async (item: SensorNormalization) => {
  try {
    loading.value = true
    await sensorNormalizationStore.refreshNormalization(item.id)
    await refreshData()
  } catch (error) {
    console.error('Error refreshing normalization:', error)
  } finally {
    loading.value = false
  }
}

onMounted(() => {
  refreshData()
})

return (_ctx: any,_cache: any) => {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_toolbar = _resolveComponent("v-toolbar")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_container, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, { cols: "12" }, {
              default: _withCtx(() => _cache[3] || (_cache[3] = [
                _createElementVNode("h1", null, "Sensor Normalizations", -1),
                _createElementVNode("p", null, "Gestión de normalizaciones de sensores", -1)
              ])),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_v_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, {
              cols: "12",
              md: "4"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_select, {
                  modelValue: selectedSensorId.value,
                  "onUpdate:modelValue": [
                    _cache[0] || (_cache[0] = ($event: any) => ((selectedSensorId).value = $event)),
                    filterBySensor
                  ],
                  items: sensorOptions.value,
                  label: "Filtrar por Sensor",
                  clearable: ""
                }, null, 8, ["modelValue", "items"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_col, {
              cols: "12",
              md: "4"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_select, {
                  modelValue: selectedSensorSettingId.value,
                  "onUpdate:modelValue": [
                    _cache[1] || (_cache[1] = ($event: any) => ((selectedSensorSettingId).value = $event)),
                    filterBySensorSetting
                  ],
                  items: sensorSettingOptions.value,
                  label: "Filtrar por Configuración",
                  clearable: ""
                }, null, 8, ["modelValue", "items"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_col, {
              cols: "12",
              md: "4"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_select, {
                  modelValue: statusFilter.value,
                  "onUpdate:modelValue": [
                    _cache[2] || (_cache[2] = ($event: any) => ((statusFilter).value = $event)),
                    filterByStatus
                  ],
                  items: statusOptions.value,
                  label: "Filtrar por Estado",
                  clearable: ""
                }, null, 8, ["modelValue", "items"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_v_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, { cols: "12" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_data_table, {
                  headers: headers,
                  items: sensorNormalizationsList.value,
                  loading: loading.value,
                  class: "elevation-1"
                }, {
                  top: _withCtx(() => [
                    _createVNode(_component_v_toolbar, { flat: "" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_toolbar_title, null, {
                          default: _withCtx(() => _cache[4] || (_cache[4] = [
                            _createTextVNode("Lista de Normalizaciones de Sensores")
                          ])),
                          _: 1
                        }),
                        _createVNode(_component_v_divider, {
                          class: "mx-4",
                          inset: "",
                          vertical: ""
                        }),
                        _createVNode(_component_v_spacer),
                        _createVNode(_component_v_btn, {
                          color: "primary",
                          onClick: refreshData
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_icon, { left: "" }, {
                              default: _withCtx(() => _cache[5] || (_cache[5] = [
                                _createTextVNode("mdi-refresh")
                              ])),
                              _: 1
                            }),
                            _cache[6] || (_cache[6] = _createTextVNode(" Actualizar "))
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_btn, {
                          color: "success",
                          class: "ml-2",
                          onClick: addItem
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_icon, { left: "" }, {
                              default: _withCtx(() => _cache[7] || (_cache[7] = [
                                _createTextVNode("mdi-plus")
                              ])),
                              _: 1
                            }),
                            _cache[8] || (_cache[8] = _createTextVNode(" Agregar Normalización "))
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  "item.sensorId": _withCtx(({ item }) => [
                    _createVNode(_component_v_chip, {
                      color: "blue",
                      variant: "outlined",
                      small: ""
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.sensorId), 1)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  "item.sensorSettingId": _withCtx(({ item }) => [
                    _createVNode(_component_v_chip, {
                      color: "green",
                      variant: "outlined",
                      small: ""
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.sensorSettingId), 1)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  "item.initDate": _withCtx(({ item }) => [
                    _createTextVNode(_toDisplayString(formatDate(item.initDate)), 1)
                  ]),
                  "item.endDate": _withCtx(({ item }) => [
                    _createTextVNode(_toDisplayString(formatDate(item.endDate)), 1)
                  ]),
                  "item.multDelta": _withCtx(({ item }) => [
                    _createVNode(_component_v_chip, {
                      color: "purple",
                      small: ""
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" ×" + _toDisplayString(item.multDelta), 1)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  "item.sumDelta": _withCtx(({ item }) => [
                    _createVNode(_component_v_chip, {
                      color: "orange",
                      small: ""
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" +" + _toDisplayString(item.sumDelta), 1)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  "item.divDelta": _withCtx(({ item }) => [
                    _createVNode(_component_v_chip, {
                      color: "teal",
                      small: ""
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" ÷" + _toDisplayString(item.divDelta), 1)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  "item.refreshed": _withCtx(({ item }) => [
                    _createVNode(_component_v_chip, {
                      color: item.refreshed ? 'success' : 'warning',
                      small: ""
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.refreshed ? 'Actualizado' : 'Pendiente'), 1)
                      ]),
                      _: 2
                    }, 1032, ["color"])
                  ]),
                  "item.status": _withCtx(({ item }) => [
                    _createVNode(_component_v_chip, {
                      color: getStatusColor(item),
                      small: ""
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(getStatusText(item)), 1)
                      ]),
                      _: 2
                    }, 1032, ["color"])
                  ]),
                  "item.actions": _withCtx(({ item }) => [
                    _createVNode(_component_v_btn, {
                      size: "small",
                      icon: "",
                      variant: "text",
                      onClick: ($event: any) => (refreshNormalization(item)),
                      disabled: item.refreshed
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, null, {
                          default: _withCtx(() => _cache[9] || (_cache[9] = [
                            _createTextVNode("mdi-refresh")
                          ])),
                          _: 1
                        }),
                        _createVNode(_component_v_tooltip, {
                          activator: "parent",
                          location: "top"
                        }, {
                          default: _withCtx(() => _cache[10] || (_cache[10] = [
                            _createTextVNode(" Actualizar normalización ")
                          ])),
                          _: 1
                        })
                      ]),
                      _: 2
                    }, 1032, ["onClick", "disabled"]),
                    _createVNode(_component_v_btn, {
                      size: "small",
                      icon: "",
                      variant: "text",
                      onClick: ($event: any) => (editItem(item))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, null, {
                          default: _withCtx(() => _cache[11] || (_cache[11] = [
                            _createTextVNode("mdi-pencil")
                          ])),
                          _: 1
                        }),
                        _createVNode(_component_v_tooltip, {
                          activator: "parent",
                          location: "top"
                        }, {
                          default: _withCtx(() => _cache[12] || (_cache[12] = [
                            _createTextVNode(" Editar normalización ")
                          ])),
                          _: 1
                        })
                      ]),
                      _: 2
                    }, 1032, ["onClick"]),
                    _createVNode(_component_v_btn, {
                      size: "small",
                      icon: "",
                      variant: "text",
                      onClick: ($event: any) => (deleteItem(item))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, null, {
                          default: _withCtx(() => _cache[13] || (_cache[13] = [
                            _createTextVNode("mdi-delete")
                          ])),
                          _: 1
                        }),
                        _createVNode(_component_v_tooltip, {
                          activator: "parent",
                          location: "top"
                        }, {
                          default: _withCtx(() => _cache[14] || (_cache[14] = [
                            _createTextVNode(" Eliminar normalización ")
                          ])),
                          _: 1
                        })
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ]),
                  _: 1
                }, 8, ["items", "loading"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})